import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const initializeNotification = () => {
    return vdkEmHappinessPortalApi.get('notifications/initializeNotification');
};
const markAsRead = (id) => {
    return vdkEmHappinessPortalApi.put(`/notifications/${id}/mark-as-read`);
};
const markAsUnread = (id) => {
    return vdkEmHappinessPortalApi.put(`/notifications/${id}/mark-as-unread`);
};
const markAllAsRead = () => {
    return vdkEmHappinessPortalApi.put(`/notifications/mark-all-as-read`);
};
const markAllAsUnread = () => {
    return vdkEmHappinessPortalApi.put(`/notifications/mark-all-as-unread`);
};
const notificationsApi = {
    initializeNotification,
    markAsRead,
    markAsUnread,
    markAllAsRead,
    markAllAsUnread
};
export default notificationsApi;
